import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../model/constants';
import { Utils } from './utils/utils';
import { Corso } from '../model/corso';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

    constructor(private http: HttpClient) { }

    getCourse(courseId: number): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'course/' + courseId;
        return this.http.get(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getCourseByModule(moduleId: number): Observable<Corso> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'course/modulo/' + moduleId;
        return this.http.get<Corso>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    getCoursesByUser(): Observable<Array<Corso>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'course/courses';
        return this.http.get<Array<Corso>>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    // downloadPdf(courseId: number, moduleId: number): Promise<Blob> {
    //     const headers = new HttpHeaders().set('Content-Type', 'application/json');
    //     const url = 'course/download/' + courseId + '/' + moduleId;
    //     const file = await this.http.get(
    //         Utils.setHost(Constants.API_ENDPOINT, url),
    //         {headers},
    //         {resp}
    //     );
    // }

    // public async downloadResource(courseId: number, moduleId: number): Promise<Blob> {
    //     const headers = new HttpHeaders().set('Content-Type', 'application/json');
    //     const url = 'course/download/' + courseId + '/' + moduleId;
    //     const file =  await this.http.get<Blob>(
    //         Utils.setHost(Constants.API_ENDPOINT, url),
    //         {responseType: 'blob' as 'json'}
    //     ).toPromise();
    //     return file;
    // }

    // downloadResource(courseId: number, moduleId: number): Promise<Blob> {
    //     // const headers = new HttpHeaders().set('Content-Type', 'application/json');
    //     const url = 'course/download/' + courseId + '/' + moduleId;
    //     const file =  this.http.get<Blob>(
    //         Utils.setHost(Constants.API_ENDPOINT, url),
    //         {responseType: 'blob' as 'json'}
    //     ).toPromise();
    //     return file;
    // }

}
